import { render } from "./MCSAPage.vue?vue&type=template&id=bdb27734&scoped=true"
import script from "./MCSAPage.vue?vue&type=script&lang=js"
export * from "./MCSAPage.vue?vue&type=script&lang=js"

import "./MCSAPage.vue?vue&type=style&index=0&id=bdb27734&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb27734"]])

export default __exports__